export default {"src":"/_next/static/media/item.357c3b92.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};